module.exports = __webpack_public_path__ + "img/peter-1.d7bf6a9d.png";